<div
  [ngClass]="visibility ? 'visible' : 'hide'"
  style="z-index: 2; position: absolute; margin-top: 280px; margin-left: 36px; width: 300px"
>
  <sysque-progress-bar
    #sysqueProgress
    [actionName]="'Searching'"
    [actionText]="'Loading Components'"
    [value]="false"
  ></sysque-progress-bar>
</div>
<div
  [ngClass]="visibility ? 'hide' : 'visible'"
  style="display: flex; flex-direction: column; z-index: 1; position: relative"
>
  <div class="result-container">
    @for (item of resultInformation; track item; let i = $index) {
      <div class="result-items-container">
        <div class="result-item-container">
          <div class="mds-btn-img">
            <div class="mds-btn">
              <img
                class="img-borderless"
                id="f_{{ i }}"
                src="{{ item.ImagePath }}"
                style="transform: rotate(0deg)"
                alt="logo"
              />
            </div>
            <div class="image-label">{{ item.NameResult }}</div>
            <dx-context-menu [dataSource]="item.sizes" target="#f_{{ i }}" (onItemClick)="itemClick($event, item)">
              <div *dxTemplate="let e of 'item'">
                <div class="item-container">
                  <div></div>
                  <div>{{ e.text }}</div>
                  @if (e.items) {
                    <span class="dx-icon-spinright menu-icon-font-size" style="margin-left: auto"></span>
                  }
                </div>
              </div>
            </dx-context-menu>
          </div>
        </div>
      </div>
    }
  </div>
  @if (showMoreBtn()) {
    <button id="showMoreBnt" class="show-more-button-enable" (click)="getNext()">
      <div class="show-more-label-enable">Show More..</div>
    </button>
  }
</div>
